import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({ baseURL: API });

export const api = {
  // Suppliers
  listSuppliers: () => client.get("/suppliers").then((r) => r.data),
  createSupplier: (data) => client.post("/suppliers", data).then((r) => r.data),
  updateSupplier: (id, data) => client.put(`/suppliers/${id}`, data).then((r) => r.data),
  deleteSupplier: (id) => client.delete(`/suppliers/${id}`).then((r) => r.data),

  // Products
  listProducts: () => client.get("/products").then((r) => r.data),
  createProduct: (data) => client.post("/products", data).then((r) => r.data),
  updateProduct: (id, data) => client.put(`/products/${id}`, data).then((r) => r.data),
  deleteProduct: (id) => client.delete(`/products/${id}`).then((r) => r.data),

  // Templates
  listTemplates: () => client.get("/templates").then((r) => r.data),
  getTemplate: (id) => client.get(`/templates/${id}`).then((r) => r.data),
  createTemplate: (data) => client.post("/templates", data).then((r) => r.data),
  updateTemplate: (id, data) => client.put(`/templates/${id}`, data).then((r) => r.data),
  deleteTemplate: (id) => client.delete(`/templates/${id}`).then((r) => r.data),

  // Orders
  listOrders: () => client.get("/orders").then((r) => r.data),
  getOrder: (id) => client.get(`/orders/${id}`).then((r) => r.data),
  createOrder: (data) => client.post("/orders", data).then((r) => r.data),
  updateOrder: (id, data) => client.put(`/orders/${id}`, data).then((r) => r.data),
  sendOrder: (id) => client.post(`/orders/${id}/send`).then((r) => r.data),
  resendOrder: (id) => client.post(`/orders/${id}/resend`).then((r) => r.data),
  deleteOrder: (id) => client.delete(`/orders/${id}`).then((r) => r.data),

  // SMTP
  getSmtp: () => client.get("/smtp-config").then((r) => r.data),
  saveSmtp: (data) => client.post("/smtp-config", data).then((r) => r.data),
  testSmtp: (data) => client.post("/smtp-config/test", data).then((r) => r.data),

  // Dashboard
  stats: () => client.get("/dashboard/stats").then((r) => r.data),

  // Import
  importItems: (file) => {
    const fd = new FormData();
    fd.append("file", file);
    return client.post("/import/items", fd, {
      headers: { "Content-Type": "multipart/form-data" },
    }).then((r) => r.data);
  },
};
